<template>
  <el-row class="h-full category-list">
    <el-col :span="8" class="JZTreeContainer content_block h-full overflow-h">
      <div class="top-bar">
        <b class="name">{{ name }}</b>
        <div v-if="$withPermission('gongxutong:base_good:category')" @click="handleAddRootCategory" class="add-root">
          <i class="el-icon-circle-plus-outline" style="font-size:16px;color:#2577e3;"></i>
          增加一级分类
        </div>
      </div>
      <el-input placeholder="输入关键字进行查询" v-model.trim="filterText" clearable prefix-icon="el-icon-search" class="margin-bottom"></el-input>
      <el-tree v-if="categoryLists && categoryLists.length" :data="categoryLists" :props="defaultProps" @node-click="handleNodeClick" node-key="id" highlight-current
        :default-expanded-keys="expandedKeys" :current-node-key="currentNodeKey" @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse" :filter-node-method="filterNode" ref="JZCategoryTree">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="custom-tree-name">{{ data.name }}</span>
          <span v-if="$withPermission('gongxutong:base_good:category')">
            <i class="el-icon-circle-plus-outline"
              :class="{ active: JZCategoryInfo && JZCategoryInfo.pid === data.id && isCurrentStatus === 3 }" type="text"
              size="mini"
              @click.self.stop.prevent="() => handleAddCategory(node, data)"></i>
            <i class="el-icon-edit-outline" type="text"
              :class="{ active: JZCategoryInfo && JZCategoryInfo.id === data.id && isCurrentStatus === 2 }"
              size="mini"
              @click.self.stop.prevent="() => handleEditCategory(node, data)"></i>
            <i class="el-icon-delete" type="text" size="mini"
              :class="{ active: JZCategoryInfo && JZCategoryInfo.id === data.id && isCurrentStatus === 4 }"
              @click.self.stop.prevent="() => handleDeleteCategory(node, data)"></i>
          </span>
        </span>
      </el-tree>
    </el-col>
    <el-col :span="16" class="JZDetailContent content_block" style="margin:0;">
      <template v-if="JZCategoryInfo">
        <div class="box-card-title">{{ isCurrentBtnText }}分类信息</div>
        <div v-if="isCurrentStatus === 1" style="padding: 20px 35px 0 15px;">
          <el-descriptions :colon="false" :column="2" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
            <el-descriptions-item label="分类名称（中文）">{{ JZCategoryInfo.name || '--' }}</el-descriptions-item>
            <el-descriptions-item label="分类名称（外文）">{{ JZCategoryInfo.nameEn || '--' }}</el-descriptions-item>
            <el-descriptions-item label="分类描述" :span="2">{{ JZCategoryInfo.remark || '--' }}</el-descriptions-item>
            <el-descriptions-item label="默认实物类型" :span="2">{{ JZCategoryInfo.materialAttribute | filterMaterialAttribute }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <el-form v-else :model="JZCategoryInfo" ref="JZCategoryInfoForm" :rules="JZCategoryInfoRules" label-width="140px"
          label-position="right" class="detailContent">
          <!-- 仅层级为2新增时，或者层级为3编辑时下拉选择 -->
          <el-form-item label="分类名称（中文）" prop="name">
            <el-input :maxlength="100" show-word-limit v-model.trim="JZCategoryInfo.name" placeholder="请输入分类名称（中文）"></el-input>
          </el-form-item>
          <el-form-item label="分类名称（外文）" prop="nameEn">
            <el-input v-model.trim="JZCategoryInfo.nameEn" placeholder="请输入分类名称（外文）"></el-input>
          </el-form-item>
          <el-form-item label="分类描述" prop="remark">
            <el-input v-model.trim="JZCategoryInfo.remark" :maxlength="200" show-word-limit type="textarea" rows="3" placeholder="请输入分类描述"></el-input>
          </el-form-item>
          <el-form-item label="默认实物类型" prop="materialAttribute">
            <el-select v-model.trim="JZCategoryInfo.materialAttribute" placeholder="请选择">
              <el-option v-for="item in materialAttributeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isCurrentStatus !== 1">
            <div style="text-align: right;">
              <el-button @click="handleCancel">取消</el-button>
              <el-button type="primary" @click="saveAndUpdateCategory">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <Empty v-else text="暂无数据，请新增" style="padding-top: 200px;" />
    </el-col>
  </el-row>
</template>
<script>
import Empty from '@/components/empty.vue';
import { getCategoryLists, addCategory, upDateCategory, deleteCategory } from '@/api/category.js';

const materialAttributeList = [
  { label: '实物', value: 'ENTITY' },
  { label: '服务', value: 'SERVICE' },
  { label: '虚拟', value: 'VIRTUAL' },
];
export default {
  name: 'CategoryLists',
  props: {
    name: {
      type: String,
    },
  },
  components: {
    Empty,
  },
  data () {
    return {
      isCurrentStatus: 0, // 状态3: 新增 2:编辑 1：查看 0:初始化状态
      categoryInfo: {},
      JZCategoryInfo: null,
      categoryLists: [],
      defaultProps: {
        children: 'childList',
        label: 'name',
      },
      filterText: '',
      currentNodeKey: '',
      expandedKeys: [0],
      materialAttributeList,
    };
  },
  filters: {
    filterMaterialAttribute (v) {
      return materialAttributeList.find(item => v === item.value)?.label || '--';
    },
  },
  computed: {
    JZCategoryInfoRules () {
      return {
        name: [
          {
            required: true,
            message: '分类名称（中文）不可为空',
            trigger: ['blur', 'change'],
          },
          {
            min: 0,
            max: 100,
            message: '分类名称（中文）不可超过100个字符',
            trigger: ['blur', 'change'],
          },
          {
            pattern: this.$store.state.common.sepecialCharts,
            message: '分类名称（中文）输入格式不可包含空格',
            trigger: ['change', 'blur'],
          },
        ],
        nameEn: [
          {
            min: 0,
            max: 100,
            message: '分类名称（外文）不可超过100个字符',
            trigger: ['blur', 'change'],
          },
          {
            pattern: this.$store.state.common.sepecialCharts,
            message: '分类名称（外文）输入格式不可包含空格',
            trigger: ['change', 'blur'],
          },
        ],
        remark: [
          {
            min: 0,
            max: 200,
            message: '分类描述不可超过200个字符',
            trigger: ['blur', 'change'],
          },
        ],
        materialAttribute: {
          required: true,
          message: '请选择默认实物类型',
          trigger: ['blur', 'change'],
        },
      };
    },
    isCurrentBtnText () {
      return this.isCurrentStatus === 2 ? '更新' : [0, 3].includes(this.isCurrentStatus) ? '新增' : '';
    },
  },
  watch: {
    filterText (val) {
      this.$refs.JZCategoryTree.filter(val);
    },
  },
  methods: {
    initPageData () {
      this.filterText = '';
      if (this.categoryLists?.length) {
        this.isCurrentStatus = 1;
        this.detailCategoryInfo(this.categoryLists[0]);
      } else {
        this.isCurrentStatus = 0;
        this.JZCategoryInfo = null;
      }
      this.$refs.JZCategoryInfoForm && this.$refs.JZCategoryInfoForm.clearValidate();
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCancel () {
      if (!this.isCurrentStatus) {
        this.JZCategoryInfo = null;
      } else {
        this.handleNodeClick(this.categoryInfo);
      }
    },
    handleNodeClick (categoryInfo) {
      // 状态3: 新增 2:编辑 1：查看 0:初始化状态
      this.isCurrentStatus = 1;
      this.detailCategoryInfo(categoryInfo);
    },
    handleDeleteCategory (node, categoryInfo) {
      this.isCurrentStatus = 4;
      this.JZCategoryInfo = categoryInfo;

      this.$confirm(`确认删除【${categoryInfo.name}】吗？`, '删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCategory({ id: categoryInfo.id }).then(async res => {
          if (res.heads.code === 200) {
            // 删除操作
            this.$JZShowAlert('删除成功！');
            await this.getCategoryLists();
            this.initPageData();
          }
        });
      }).catch(() => {});
    },
    handleAddRootCategory () {
      // 状态1: 新增 2:编辑 3：查看
      this.isCurrentStatus = 0;
      this.detailCategoryInfo({});
    },
    handleEditCategory (node, categoryInfo) {
      // 状态3: 新增 2:编辑 1：查看 0:初始化状态
      this.isCurrentStatus = 2;
      this.detailCategoryInfo(categoryInfo);
    },
    handleAddCategory (node, categoryInfo) {
      // 状态1: 新增 2:编辑 3：查看
      this.isCurrentStatus = 3;
      this.detailCategoryInfo(categoryInfo);
    },
    async getCategoryLists () {
      const rs = await getCategoryLists({ pid: 0 });
      if (rs.heads.code === 200) {
        this.categoryLists = rs?.body || [];
        this.initPageData();
      }
    },
    handleNodeExpand (data) {
      // 保存当前展开的节点
      let flag = false;
      this.expandedKeys.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.expandedKeys.push(data.id);
      }
    },
    // 树节点关闭
    handleNodeCollapse (data) {
      this.expandedKeys.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.expandedKeys.length = i;
        }
      });
    },
    detailCategoryInfo (categoryInfo = {}) {
      this.categoryInfo = categoryInfo;
      this.currentNodeKey = categoryInfo.id;
      let currentForm = {};
      if (this.isCurrentStatus === 0) {
        currentForm = currentForm = {
          name: categoryInfo.name || '',
          nameEn: categoryInfo.nameEn || '',
          remark: categoryInfo.remark || '',
          pid: 0,
        };
      } else if ([1, 2].indexOf(this.isCurrentStatus) !== -1) {
        currentForm = {
          pid: categoryInfo.pid,
          id: categoryInfo.id || '0',
          name: categoryInfo.name || '',
          nameEn: categoryInfo.nameEn || '',
          remark: categoryInfo.remark || '',
          relationList: categoryInfo.relationList || [],
        };
      } else if (this.isCurrentStatus === 3) {
        currentForm = {
          pid: categoryInfo.id,
          name: '',
          nameEn: '',
          remark: '',
        };
      }
      currentForm.level = categoryInfo.level;
      currentForm.materialAttribute = categoryInfo.materialAttribute;
      this.JZCategoryInfo = currentForm;
      this.$nextTick(() => {
        this.$refs.JZCategoryInfoForm && this.$refs.JZCategoryInfoForm.clearValidate();
      });
    },
    saveAndUpdateCategory () {
      this.$refs.JZCategoryInfoForm.validate(valid => {
        if (valid) {
          let currentParams = JSON.parse(JSON.stringify(this.JZCategoryInfo));
          if ([0, 3].includes(this.isCurrentStatus)) {
            addCategory(currentParams).then(res => {
              this.saveAndUpdateCategorySuccssFun(res);
            });
          } else if (this.isCurrentStatus === 2) {
            upDateCategory(currentParams).then(res => {
              this.saveAndUpdateCategorySuccssFun(res);
            });
          }
        }
      });
    },
    saveAndUpdateCategorySuccssFun (res) {
      if (res.heads.code === 200) {
        let currentMessage = [0, 3].includes(this.isCurrentStatus) ? '创建成功！' : '更新成功！';
        this.$JZShowAlert(currentMessage);
        this.initPageData();
        this.getCategoryLists();
      }
    },
  },
  created () {
    this.getCategoryLists();
  },
};
</script>
<style lang="scss" scoped>
.category-list {
  display: flex;
  height: 100%;
}

.top-bar {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 15px;
  .name {
    font-weight: 600;
    font-size: 14px;
    color: #1F2733;
  }
  .add-root {
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #237FFA;
    cursor: pointer;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 32px;
  border-radius: 4px;

  i {
    /* color: #409eff; */
    font-size: 14px;
    color: #d3d3d3;
    padding: 0 5px;

    &.active {
      color: #5195eb;
    }
  }

  .custom-tree-name {
    max-width: 500px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.JZTreeContainer {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 6px;
  margin-right: 10px;

  &>.el-tree {
    flex: 1;
    overflow: auto;
    padding-top: 10px;
  }
}

.JZDetailContent {
  background: #fff;
  overflow-y: auto;
  border-radius: 6px;

  .box-card-title {
    padding-bottom: 15px;
    font-weight: 600;
    font-size: 14px;
    color: #1F2733;
    border-bottom: 1px solid #eeeeee;
  }

  .detailContent {
    padding: 20px;
  }

  .prevdirectory {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.categoryInfoContainer_title {
  width: 200px;
  height: 50px;
  color: #333333;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  border: 1px solid rgba(121, 121, 121, 1);
  margin-bottom: 40px;
}

/deep/ .el-tree-node.is-current > .el-tree-node__content {
    background-color: #E2F3FE;
    color: #237FFA;
}

/deep/ .descriptionsLabel {
  width: 120px;
  text-align: right;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #929aa6;
  letter-spacing: 0;
  text-align: right;
  line-height: 30px;
}
/deep/ .descriptionsValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1f2733;
  letter-spacing: 0;
  text-align: left;
  line-height: 30px;
  display: flex;
}
</style>
